<template>
    <div class="modal-card request-company-card">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered is-size-4">
                Solicitar otra empresa
            </h3>
            <button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
        </header>
        <section class="modal-card-body">
            <p class="help-text">
                Un analista revisará tu solicitud. Cuando la resuelva verás el
                resultado en tu menú de usuario.
            </p>
            <b-field>
                <b-checkbox v-model="isForeign">
                    Empresa extranjera (sin RUT chileno)
                </b-checkbox>
            </b-field>
            <b-field :label="identifierLabel">
                <b-input v-model="companyRut" :placeholder="identifierPlaceholder"
                    :maxlength="isForeign ? 24 : 12" :has-counter="false" />
            </b-field>
            <b-field label="Nombre / Razón social">
                <b-input v-model="companyName" placeholder="Razón social" maxlength="255"
                    :has-counter="false" />
            </b-field>
            <b-field label="Tu rol en la empresa">
                <b-select v-model="role" expanded aria-label="Rol en la empresa">
                    <option value="">Sin rol</option>
                    <option v-for="option in roleOptions" :key="option.value" :value="option.value">
                        {{ option.label }}
                    </option>
                </b-select>
            </b-field>
        </section>
        <footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
            <button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
                Volver
            </button>
            <button class="button is-primary" :disabled="loading || !canSubmit" role="button"
                @click="submit">
                Enviar solicitud
            </button>
        </footer>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { ROLE_OPTIONS } from "@/utils/roles";
import { notificate, consoleHandlerError } from "@/utils/message";

export default {
    name: "RequestCompanyModal",
    data() {
        return {
            companyRut: "",
            companyName: "",
            // Empresa extranjera: identificador fiscal del país (RUC, CUIT…),
            // validado genérico por el backend (TaxIdValidator).
            isForeign: false,
            role: "",
            loading: false,
            roleOptions: ROLE_OPTIONS,
        };
    },
    computed: {
        canSubmit() {
            return this.companyRut.trim().length > 0 && this.companyName.trim().length > 1;
        },
        identifierLabel() {
            return this.isForeign
                ? "Identificador fiscal (RUT, RUC, etc.)"
                : "RUT de la empresa";
        },
        identifierPlaceholder() {
            return this.isForeign ? "Ej. 30-71234567-8" : "12.345.678-9";
        },
    },
    watch: {
        // Al cambiar de universo el identificador tipeado no aplica.
        isForeign() {
            this.companyRut = "";
        },
    },
    methods: {
        ...mapActions("companyLinkRequests", ["createRequest"]),
        async submit() {
            this.loading = true;
            try {
                await this.createRequest({
                    company_rut: this.companyRut,
                    company_name: this.companyName,
                    is_foreign: this.isForeign === true,
                    role: this.role,
                });
                notificate(
                    "Solicitud enviada. Un analista la revisará.",
                    "is-success is-light",
                    "is-top-right",
                    false,
                    5000
                );
                this.$emit("close");
            } catch (error) {
                // El backend rechaza con {detail} (ya perteneces / solicitud
                // pendiente) o con errores por campo del serializer
                // (company_rut → "El rut ingresado es inválido"). Mostramos el
                // más específico disponible.
                const data = error && error.response && error.response.data;
                const message = (data && (
                    data.detail
                    || (data.company_rut && data.company_rut[0])
                    || (data.company_name && data.company_name[0])
                )) || "No se pudo enviar la solicitud.";
                notificate(message, "is-danger is-light", "is-top-right", false, 5000);
                consoleHandlerError({ error });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.request-company-card {
    width: clamp(320px, 90vw, 520px);
}

.help-text {
    margin-bottom: 16px;
    font-size: 13px;
    line-height: 1.45;
    color: var(--report-text-muted, #6b7280);
}
</style>
